import { UserInfo } from "@/services/users/types/user.types";
import { getOnlyDigits, isValidCpf } from "@/utils/cpf";

/** Participante já avançou além da 1ª etapa (classificação / etapa regional). */
export function isPastFirstRealityStage(
  currentStageNumber: number,
  advancedToResultStage = false
): boolean {
  if (advancedToResultStage) return true;
  return currentStageNumber > 1;
}

/**
 * When the participant is past the first stage, complementary profile fields must be filled.
 * Kept in sync with Profile `isValid` when `currentStageNumber > 1`.
 */
export function isPostAdvanceProfileComplete(
  user: UserInfo | undefined,
  currentStageNumber: number,
  advancedToResultStage = false
): boolean {
  if (!isPastFirstRealityStage(currentStageNumber, advancedToResultStage)) {
    return true;
  }
  if (!user?.id) return false;
  return !!(
    user.shoeSize?.trim() &&
    user.shirtSize?.trim() &&
    user.pantsSize?.trim() &&
    user.gloveSize?.trim() &&
    user.address?.trim() &&
    user.numberAddress?.trim() &&
    user.neighborhood?.trim() &&
    user.cep?.trim() &&
    user.addressProofUrl?.trim() &&
    user.identityDocumentUrl?.trim() &&
    user.motherName?.trim() &&
    user.birthPlace?.trim() &&
    user.maritalStatus?.trim() &&
    user.rgRne?.trim() &&
    user.rgIssuingAgency?.trim() &&
    !!user.rgIssueDate
  );
}

/**
 * True when phone is validated but required post-OTP data are still missing.
 */
export function needsCompleteRegistration(user: UserInfo | undefined): boolean {
  if (!user?.id) return false;
  if (!user.phoneNumberValidated) return false;

  const cpfDigits = getOnlyDigits(user.cpf ?? "");
  if (cpfDigits.length !== 11 || !isValidCpf(cpfDigits)) return true;

  if (!user.imageUrl?.trim()) return true;

  return false;
}
